import { render } from "./ProductionDocumentsView.vue?vue&type=template&id=a8a4200a"
import script from "./ProductionDocumentsView.vue?vue&type=script&lang=js"
export * from "./ProductionDocumentsView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__